import { WasmLoader } from '@seddi/core';
import { GarmentGeometryModule } from '@seddi/ui-babylon-scene';
import { RecolorModule } from '@seddi/ui-recolor';
import WaAvatars from '@seddi/wa-avatars';
import log from 'loglevel';

import {
  AxiosProgressHandler,
  fetchCache,
  deleteUnknownCaches,
  openCache,
  validateCaches,
} from '../cache';
import { WA_AVATARS_FS_URL } from '../constants';

import wasmAvatarsUrl from '@seddi/wa-avatars/lib/index.wasm';

const WA_AVATARS_FS_VERSION = '2';
const WA_AVATARS_FS_KEY = `fitroom.widget.avatars.${WA_AVATARS_FS_VERSION}`;

/**
 * Load app wasm.
 * @param onDownloadProgress Download progress handler.
 */
export const appLoadWasm = async (onDownloadProgress?: AxiosProgressHandler) => {
  // Validate Cache support.
  validateCaches();

  // Keep Cache clean.
  deleteUnknownCaches([WA_AVATARS_FS_KEY]);

  log.trace('[Fitroom] Loading wasm');

  try {
    // Fetch @seddi/wa-avatars filesystem through cache.
    const cache = await openCache(WA_AVATARS_FS_KEY);

    const wasmAvatarsFs = await fetchCache(cache, WA_AVATARS_FS_URL, onDownloadProgress).then(
      response => response.arrayBuffer(),
    );

    // Fetch wasm binaries
    const [wasmAvatarsBuf] = await Promise.all([
      fetch(wasmAvatarsUrl).then(res => res.arrayBuffer()),
    ]);
    const wasmAvatars = new Uint8Array(wasmAvatarsBuf);

    // Init wasm modules
    await Promise.all([
      GarmentGeometryModule.init(),
      RecolorModule.init(),
      WasmLoader.Load(WaAvatars, wasmAvatars, {
        getPreloadedPackage: () => wasmAvatarsFs,
      }),
    ]);
  } catch (error) {
    log.error('[Fitroom] Error loading wasm', error);
    throw error;
  }

  log.trace('[Fitroom] Loaded wasm');
};
